import { ActionCreator, Action } from 'redux';
import { BuyerPermissions } from '@/types';

export const setBuyerPermissions: ActionCreator<Action> = (data: BuyerPermissions | null) => ({
    type: 'SET_BUYER_PERMISSIONS',
    data,
});

export const clearBuyerPermissions: ActionCreator<Action> = () => ({
    type: 'CLEAR_BUYER_PERMISSIONS',
});